import { render } from "./BannerCreate.vue?vue&type=template&id=15ab6c78&scoped=true"
import script from "./BannerCreate.vue?vue&type=script&lang=js"
export * from "./BannerCreate.vue?vue&type=script&lang=js"

import "./BannerCreate.vue?vue&type=style&index=0&id=15ab6c78&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ab6c78"]])

export default __exports__